import React from 'react'
import Button from '../../common/components/Button';
import { activateLicense, getInstallLink, openHub } from '../../common/js/bfx-hub-utility';
import { getHubInstallerUrl } from '../data/hub-installers';
import useHubCheck from '../hooks/useHubCheck';

export default function LicenseBox({license, displayExpiration, family, version, hubInstalled=true}) {
    const [clicked, setClicked] = React.useState(false);
    const [copied, setCopied] = React.useState(false);
    const [processing, setProcessing] = React.useState(false);

    const fam = React.useMemo(() => family || license.product.familyName, [family]);

    let activationKey = license.serial;
    //activationKey = activationKey.replaceAll('-', ' - ');

    const handleActivate = () => {
        setClicked(true);
        activateLicense(license.serial, license.product.familyName, true);
    };

    const handleCopy = () => {
        navigator.clipboard.writeText(license.serial);
        setCopied(true);
    };

    const handleInstall = () => {
        const uri = getInstallLink(fam, version);
        window.location.href = uri;
    }
    
    const getLabel = () => {
        /*
        if (!hubInstalled){
            return 'Install the Hub';
        }
        */
        if (!clicked){
            return 'Activate';
        }
        else if (!copied){
            return 'Copy';
        }
        else{
            return '&check;';
        }
    }

    const getOnClick= () => {
        /*
        if (!hubInstalled){
            return handleInstall;
        }
        */
        if (!clicked){
            return handleActivate;
        }
        else if (!copied){
            return handleCopy;
        }
        else{
            return null
        }
    }

    const buttonLabel = React.useMemo(getLabel, [clicked, copied, hubInstalled]);
    const buttonOnClick = React.useMemo(getOnClick, [clicked, copied, hubInstalled]);

    let expirationText = 'Permanent License';
    if (license.expires != null){
        expirationText = `Expiration date: ${license.expires}`
    }

    if (license.recordType == 'login_license') {
        return (
        <div className='standard-license-box-container' style={{justifyContent: 'flex-start'}}>
            <div className='license-button-container'>
                <Button label='Enable in Hub' onClick={() => openHub(fam)} className='btn-new btn-new-compact license-button' />
            </div>
            {getHubInstallerUrl(fam) && (
                <p style={{fontSize: '14px', margin: '8px 0 0'}}>
                    Don't have Boris FX Hub yet? <a href={getHubInstallerUrl(fam)}>Download Here</a>
                </p>
            )}
        </div>
        )
    }

    return (
    <div className='license-box-container'>
        {displayExpiration && (
            <div className='license-expiration'>
                <span className='license-expiration-text'>
                    {expirationText}
                </span>
            </div>
        )}
        <div className='license-box'>
            <span>{activationKey}</span>
        </div>
        <div className='license-button-container'>
            <Button label={buttonLabel} onClick={buttonOnClick} processing={processing} className='btn license-button' />
        </div>
        {getHubInstallerUrl(fam) && (
            <p style={{fontSize: '14px', margin: '8px 0 0'}}>
                Don't have Boris FX Hub yet? <a href={getHubInstallerUrl(fam)}>Download Here</a>
            </p>
        )}

        <dialog>
            <h5></h5>
        </dialog>
    </div>
    )
}